module.exports = "p.info {\n    font-size: 14px;\n}"